import React from 'react';

import Skeleton from 'react-loading-skeleton';

export default function BaseTile({ title, value, icon, link, loading = false }) {
    const Tag = link ? 'a' : 'div';

    return (
        <Tag className="tw-px-4 tw-py-3 tw-rounded-lg tw-border-2 tw-border-grey" href={link}>
            {!loading ? (
                <div className="tw-flex tw-items-center tw-justify-between">
                    <div>
                        <div className="tw-text-sm tw-text-blue-75 tw-font-medium mb-2">{title}</div>
                        <div className="tw-text-2.5xl tw-text-charcoal tw-font-semibold">{value}</div>
                    </div>
                    {icon && <div>{icon}</div>}
                </div>
            ) : (
                <div className="tw-space-y-2 tw-h-full">
                    <Skeleton width="100px" height={20} />
                    <Skeleton width="180px" height={28} />
                </div>
            )}
        </Tag>
    );
}
